import { TerminalMode } from "@services";

export interface GuavaSession {
  id: string;
  status: string;
  orderId: string;
  terminalId: string;
  expireAt: Date;
  createdAt: Date;
  updatedAt: Date;
  hasError: boolean;
  errorMessage?: string;
}

export interface CreatePaymentTrackingRequest {
  invoiceId: string;
  amount: number;
}

export interface PaymentTrackingResponse {
  id: string;
  tenantId: number;
  invoiceId: string;
  status: string;
  message: string;
  amount: number;
}

export interface ProcessPaymentRequest {
  paymentTrackingId: string;
  invoiceId: string;
  amount: number;
  terminalMode: TerminalMode;
}

export interface ProcessPaymentResponse {
  success: boolean;
  message: string;
}

export interface PaymentStatusResponseDto {
  statusMessage: string;
  terminalMessage?: string;
  status: string;
  order: number;
  trackingId?: string;
  /** The card machine result is unknown: the operator must confirm whether it was approved. */
  requiresConfirmation?: boolean;
  /** The API has already recorded the payment for this attempt. */
  paymentRecorded?: boolean;
  /** 'Sale' | 'UnlinkedRefund' */
  sessionType?: string;
  amount?: number;
  creationTime?: string;
  terminalSessionStatus?: string;
}

/** Values of PaymentTracking.Status (mirrors Sopro.ZeroGeek.Core.Shared.Payments.PaymentTrackingStatus). */
export const PaymentTrackingStatus = {
  Initialized: 'INITIALIZED',
  WaitingPayment: 'WAITING_PAYMENT',
  Reconnecting: 'RECONNECTING',
  Paid: 'PAID',
  Failed: 'FAILED',
  Error: 'ERROR',
  Unconfirmed: 'UNCONFIRMED',
  ManualPaid: 'MANUAL_PAID',
  ManualFailed: 'MANUAL_FAILED',
  Timeout: 'TIMEOUT',
} as const;

export interface ResolveUnconfirmedPaymentRequest {
  trackingId: string;
  paidOnTerminal: boolean;
  note?: string;
}

export interface CancelTerminalPaymentRequest {
  trackingId: string;
}

export interface VerifySignatureRequest {
  trackingId: string;
  isValid: boolean;
};